import React from 'react';
import withData from '../../../../core/containers/withData';
import Box from '../../../../components/Box';
import Spinner from '../../../../components/Spinner';

class LastResults extends React.Component {
  renderRows() {
    const { data, team } = this.props;

    if (!data || !data.length) {
      return null;
    }

    let rows = [];

    data.map(row => {
      if (!row.game_stats || !row.game_stats.length) {
        return null;
      }

      const homeStats = row.game_stats.filter(s => s.team === row.home_team.id)[0];
      const awayStats = row.game_stats.filter(s => s.team === row.away_team.id)[0];

      if (!homeStats || !awayStats) {
        return null;
      }

      return rows.push(
        <tr key={ row.id }>
          <td>
            { row.game_stats.filter(s => s.team.toString() === team)[0].won ?
              <span className="label label-success label-round">W</span> :
              <span className="label label-danger label-round">L</span>
            }
          </td>
          <td>{ row.game_date }</td>
          <td>{ row.league.name }</td>
          <td className="text-capitalize">{ row.step.name.toLowerCase() }</td>
          <td>{ row.home_team.name }</td>
          <td>{ homeStats.points }</td>
          <td>{ homeStats.q1_points }</td>
          <td>{ homeStats.q2_points }</td>
          <td>{ homeStats.q3_points }</td>
          <td>{ homeStats.q4_points }</td>
          <td>{ homeStats.ot1_points || '' }</td>
          <td>{ row.away_team.name }</td>
          <td>{ awayStats.points }</td>
          <td>{ awayStats.q1_points }</td>
          <td>{ awayStats.q2_points }</td>
          <td>{ awayStats.q3_points }</td>
          <td>{ awayStats.q4_points }</td>
          <td>{ awayStats.ot1_points || '' }</td>
        </tr>
      );
    });

    return rows;
  }

  render() {
    const { last, combined, isFetching } = this.props;

    return (
      <Box title={ `Last ${last} Games Results ${combined ? '(combined)': ''}` }
           className="table-responsive">
        { isFetching && <Spinner /> }
        <table className="table table-bordered table-hover table-stats">
        <tbody>
          <tr>
            <th></th>
            <th>Date</th>
            <th>League</th>
            <th>Step</th>
            <th>Home Team</th>
            <th>Score</th>
            <th>Q1</th>
            <th>Q2</th>
            <th>Q3</th>
            <th>Q4</th>
            <th>OT</th>
            <th>Away Team</th>
            <th>Score</th>
            <th>Q1</th>
            <th>Q2</th>
            <th>Q3</th>
            <th>Q4</th>
            <th>OT</th>
          </tr>
          { this.renderRows() }
        </tbody>
        </table>
      </Box>
    );
  }
};

export default withData(LastResults);



// WEBPACK FOOTER //
// ./src/features/scout-report/components/LastResults/LastResults.js